import React from 'react'

export const Footer = () => {
	return (
		<div className="footer-container">
			<div className="footer-main">
				<div className="main-links-container">
					<div className="powered-by-logo">
						<span style={{ color: '#ffffffb3' }}>Powered by</span>
						<img
							style={{
								height: 20,
								filter: 'invert(1)',
							}}
							src="/rndm-logo.png"
							alt="rndm logo"
						/>
					</div>

					<div>
						<span className="links">Terms</span>
						<span className="links">Privacy</span>
						<span className="links">Contact</span>
					</div>
				</div>
				<div
					style={{
						width: '100%',
						height: 1,
						backgroundColor: '#D1D5DB',
					}}
				/>

				<div className="arr-container">
					<span>© 2025 Agent Jeeves. All rights reserved.</span>
					<span>
						Agent Jeeves is not a financial advisor. Use at your own
						risk.
					</span>
				</div>
			</div>
		</div>
	)
}
